import {
  API_VERSION,
  SIGNALR_HUBNAME,
  SUBSCRIPTION_SERVICE,
  X_API_VERSION,
} from "../../../constants";
import { apiOptions, apiRequest } from "../../../utils";

const API_NEGOTIATION = `${SUBSCRIPTION_SERVICE}/negotiation`;

export const negotiation = {
  users: async ({ data }) => {
    const options = await apiOptions({
      url: `${API_NEGOTIATION}/${SIGNALR_HUBNAME}`,
      method: "post",
      headers: { [X_API_VERSION]: API_VERSION },
      data,
    });
    return apiRequest(options);
  },
};
